import React, { Component } from 'react'
import _ from 'lodash'
import clientId from 'clientId'
import './style.css'

export default class Footer extends Component {
  render() {
    return (
      <div className="footer">
        {(clientId == 'hkspop' && (
          <div>
            <div className="copyright">
              <div>
                Copyright &copy; 2010-2019 源大數據科技有限公司（香港）uMax Data
                Technology Limited （Hong Kong）
              </div>
              <div>查詢電話：(852) 3975 2379</div>
            </div>
            <div className="copyright margin-top-md">
              爲了能獲得最佳的用戶體驗，建議通過瀏覽器（IE9或以上、Firefox、Safari、Chrome、Opera等）登錄源大網上信息閱讀平台
              sPOP，同時最佳解析度為1440*900或以上。
            </div>
          </div>
        )) || (
          <div>
            <div className="copyright">
              <div>
                Copyright &copy; 2010-2019 易研信息科技有限公司 版權所有
              </div>
            </div>
            <div className="copyright margin-top-md">
              爲了能獲得最佳的用戶體驗，建議通過瀏覽器（IE9或以上、Firefox、Safari、Chrome、Opera等）登錄易研網上信息閱讀平台
              sPOP，同時最佳解析度為1440*900或以上。
            </div>
          </div>
        )}
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/footer/components/Footer.js
 **/